import { func } from 'prop-types';
import React from 'react';
import {Default,Mobile} from '../../Sizes';
import style from './style';

const TooltipBase = ({render,...props}) => {
	const Tooltip =  (
		<style.Tooltip id="tooltip">
			{render()}
		</style.Tooltip>
	);
	return (
		<React.Fragment>
			<Default>
				<style.OverlayTrigger {...props} overlay={Tooltip}/>
			</Default>
			<Mobile>
				{props.children}
			</Mobile>
		</React.Fragment>
	);
    
};

TooltipBase.propTypes = {
	render: func,
};

export default TooltipBase;